module.exports = __webpack_public_path__ + "static/nielsen-52ce90eebe2b22acb1a73b42adacd9f9.svg";